import { RefObject } from 'react';

import { BaseFormMessage, FormMessageType, SetFormScriptMessage } from '@gn-audio/jss-core';

const createFormSubmitHandler = (messageType: FormMessageType, callback: () => void) => {
  return (event: MessageEvent) => {
    if (event.data.type === messageType) {
      callback();
    }
  };
};

export const handleFormAfterSubmit = (callback: () => void) =>
  createFormSubmitHandler(FormMessageType.AfterSubmit, callback);

export const handleFormSubmit = (callback: () => void) =>
  createFormSubmitHandler(FormMessageType.Submit, callback);

export const handleFormPreSubmit = (callback: () => void) =>
  createFormSubmitHandler(FormMessageType.PreSubmit, callback);

export const postFormSubmit = (iframeRef: RefObject<HTMLIFrameElement | null>, data: unknown) => {
  if (!iframeRef.current) {
    return;
  }

  const iframe = iframeRef.current;
  iframe.contentWindow?.postMessage(
    {
      type: FormMessageType.Submit,
      data: data,
    },
    '*'
  );
};

export const postFormScript = (
  iframeRef: RefObject<HTMLIFrameElement | null>,
  formScript: string
) => {
  if (!iframeRef.current || !formScript) return;

  const message: SetFormScriptMessage = {
    type: FormMessageType.SetFormScript,
    formScript,
  };

  iframeRef.current.contentWindow?.postMessage(message, '*');
};

export const setFormControlValue = (
  iframeRef: RefObject<HTMLIFrameElement>,
  controlName: string,
  value: unknown,
  propertyName: string = 'value'
) => {
  if (!iframeRef.current) {
    return;
  }

  const iframe = iframeRef.current;
  iframe.onload = () => {
    iframe.contentWindow?.postMessage(
      {
        type: FormMessageType.SetControl,
        controlName,
        propertyName,
        value,
      },
      '*'
    );
  };
};

export const handleFormMessage = <T extends FormMessageType>(
  messageType: T,
  callback: (event: MessageEvent<BaseFormMessage>) => void
) => {
  return (event: MessageEvent<BaseFormMessage>) => {
    if (event.data.type === messageType) {
      callback(event);
    }
  };
};
